export default __webpack_public_path__ + "static/media/minisite-pagetype-home.df04f46e.svg";